import { printVisibility } from '@/features/styles/lib/printStyles';
import { Box, Button, Flex, Icon, Text } from '@/ui';
import type { AddViewFlow } from './useAddViewFlow';

type Props = AddViewFlow;

export const AddViewTopBar = ({
  canConfirm,
  isPending,
  mode,
  parentTitle,
  confirm,
  cancel,
}: Props) => {
  const isCreating = mode === 'create';
  const heading = isCreating ? 'Add a view' : 'Change layout';
  const primaryLabel = isCreating ? 'Add this view' : 'Use this layout';

  return (
    <Flex
      align="center"
      bg="surface.panel"
      borderBottom="1px solid"
      borderColor="line.panel"
      flexShrink={0}
      gap={3}
      h="ah-bar"
      px={4}
      sx={printVisibility.hide()}
    >
      {/* Left: sparkle tile + breadcrumb */}
      <Flex align="center" gap={2.5} minW={0}>
        <Flex
          align="center"
          borderRadius="ah-md"
          color="magicPurple.500"
          flexShrink={0}
          h="32px"
          justify="center"
          layerStyle="ahIconChip"
          w="32px"
        >
          <Icon icon="WandSparkles" size={4} />
        </Flex>
        <Flex align="baseline" gap={1.5} minW={0} overflow="hidden">
          <Text
            color="ink.strong"
            flexShrink={0}
            fontSize="ah-control"
            fontWeight={700}
          >
            {heading}
          </Text>
          {parentTitle && (
            <>
              <Text color="ink.muted" flexShrink={0} fontSize="ah-control">
                /
              </Text>
              <Text
                color="ink.muted"
                fontSize="ah-control"
                overflow="hidden"
                textOverflow="ellipsis"
                whiteSpace="nowrap"
              >
                {parentTitle}
              </Text>
            </>
          )}
        </Flex>
      </Flex>

      <Box flex={1} />

      {/* Right: Cancel + primary */}
      <Flex align="center" flexShrink={0} gap={2}>
        <Button
          leftIcon={<Icon icon="X" size={4} />}
          size="ah-sm"
          variant="ahSecondary"
          onClick={cancel}
        >
          Cancel
        </Button>
        <Button
          isDisabled={!canConfirm}
          isLoading={isPending}
          leftIcon={<Icon icon={isCreating ? 'Plus' : 'Checkmark'} size={4} />}
          size="ah-sm"
          variant="ahPrimary"
          onClick={confirm}
        >
          {primaryLabel}
        </Button>
      </Flex>
    </Flex>
  );
};
